import { useEffect } from "react";

type HotkeyEvent = Pick<
  KeyboardEvent,
  "key" | "metaKey" | "ctrlKey" | "target"
> & { code?: string };

/** Атрибут на модальном листе помощника: его собственная модалка не мешает горячим клавишам. */
export const ASSISTANT_MODAL_ATTR = "data-partner-assistant";

const isTyping = (target: EventTarget | null) => {
  const el = target as { tagName?: string; isContentEditable?: boolean } | null;
  return Boolean(
    el &&
      (el.isContentEditable ||
        ["INPUT", "TEXTAREA", "SELECT"].includes(el.tagName ?? ""))
  );
};

/**
 * Открыт чужой диалог MUI: его ловушка фокуса вернула бы фокус обратно,
 * а панель помощника лежит под его фоном. Клавиши тогда не перехватываются.
 */
const foreignModalOpen = () =>
  Boolean(
    document.querySelector(
      `.MuiModal-root:not(.MuiModal-hidden):not([${ASSISTANT_MODAL_ATTR}])`
    )
  );

/**
 * «/» вне полей ввода и Cmd+K (Ctrl+K) где угодно (п. 9 спеки). K ловится и
 * по физической клавише (code): в русской раскладке key у неё «л».
 */
export function isAssistantHotkey(e: HotkeyEvent): boolean {
  const isK = e.key.toLowerCase() === "k" || e.code === "KeyK";
  const cmdK = isK && (e.metaKey || e.ctrlKey);
  return cmdK || (e.key === "/" && !isTyping(e.target));
}

export function useAssistantHotkeys(focus: () => void) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (isAssistantHotkey(e) && !foreignModalOpen()) {
        e.preventDefault();
        focus();
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [focus]);
}
